import "./App.css";

//------------patient --------------------------------------//
import PatientDashboard from "./pages/patient/dashboard/dashboard";
import Profile from "./pages/patient/profile/profile";
import PatientLayout from "./layouts/patient-layout";
import MyHealthCard from "../src/pages/patient/health/my-health-card";
import FindHealthService from "../src/pages/patient/health/find-health-service";
import BookingHistory from "../src/pages/patient/booking/booking-history";
import DownloadReport from "../src/pages/patient/report/download-report";
import Home from "../src/pages/home/home";
import PatientLogin from "./pages/patient/auth/patientLogin";

//------------admin --------------------------------------//

import CreateDoctor from "./pages/admin/role/create-doctor";
import CreateEmployee from "./pages/admin/role/create-employee";
import CreateLabDiagnostic from "./pages/admin/role/create-lab-diagnostic";
import CreatePharmacy from "./pages/admin/role/create-pharmacy";
import HealthCardMaster from "./pages/admin/health-card/health-card-master";
import CreateRole from "./pages/admin/role/create-role";
import AdminLogin from "./pages/admin/auth/adminLogin";
import AdminLayout from "./layouts/admin-layout";
import AdminDashboard from "./pages/admin/dashboard/adminDashboard";

//------------------other-------------------------------//
import NotFound from "../src/pages/page-not-found";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EmployeeLogin from "./pages/employee/auth/login";
import CreatePatient from "./pages/admin/role/create-patient";
import CreateBranch from "./pages/admin/branch/createBranch";
import { ProtectPatientRoute } from "./components/ProtectedRoute/ProtectPatientRoute";
import { ProtectAdminRoute } from "./components/ProtectedRoute/ProtectAdminRoute";
import EmployeeLayout from "./layouts/employee-layout";
import EmployeeDashboard from "./pages/employee/dashboard/dashboard";
import { ProtectEmployeeRoute } from "./components/ProtectedRoute/ProtectEmployeeRoute";
import ManageCompany from "./pages/admin/company/ManageCompany";
import AdminLoginHistory from "./pages/admin/loginHistory/adminLoginHistory";
import RolePermission from "./pages/admin/role/role-permission";

function App() {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        closeButton={false}
        toastClassName="bg-transparent shadow-none p-0"
        bodyClassName="p-0"
        newestOnTop
      />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/patient-login" element={<PatientLogin />} />

        {/* Patient */}
        <Route element={<ProtectPatientRoute />}>
          <Route element={<PatientLayout />}>
            <Route path="/patient-dashboard" element={<PatientDashboard />} />
            <Route path="/my-health-card" element={<MyHealthCard />} />
            <Route
              path="/find-health-service"
              element={<FindHealthService />}
            />
            <Route path="/booking-history" element={<BookingHistory />} />
            <Route path="/download-report" element={<DownloadReport />} />
            <Route path="/profile" element={<Profile />} />
          </Route>
        </Route>

        {/* Admin */}
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/employee-login" element={<EmployeeLogin />} />
        <Route element={<ProtectAdminRoute />}>
          <Route element={<AdminLayout />}>
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/create-role" element={<CreateRole />} />
            <Route path="/role-permission" element={<RolePermission />} />
            <Route path="/create-employee" element={<CreateEmployee />} />
            <Route path="/create-doctor" element={<CreateDoctor />} />
            <Route path="/create-pharmacy" element={<CreatePharmacy />} />
            <Route path="/create-patient" element={<CreatePatient />} />
            <Route path="/create-branch" element={<CreateBranch />} />
            <Route path="/manage-company" element={<ManageCompany />} />
            <Route path="/health-card-master" element={<HealthCardMaster />} />
            <Route path="/admin-login-history" element={<AdminLoginHistory />} />
         
            <Route
              path="/create-lab-diagnostic"
              element={<CreateLabDiagnostic />}
            />
          </Route>
        </Route>

        {/* employee */}
        <Route element={<ProtectEmployeeRoute />}>
          <Route element={<EmployeeLayout />}>
            <Route path="/employee-dashboard" element={<EmployeeDashboard />} />
          </Route>
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
